import { apiUrl } from '../../Utils/Environment';

const ApiUrlConstant = {
  loginService: () => `${apiUrl}/api/accounts/login/`,
  getPatientByEmail: (shopify_Id) => `${apiUrl}/api/accounts/patients/by-email/?shopify_customer_id=${shopify_Id}`,
  getAccess: (email) => `${apiUrl}/api/accounts/patients/by-email/?email=${email}`,
  signupService: () => `${apiUrl}/api/accounts/auth/set-password/`,
  verifyOtpService: () => `${apiUrl}/api/accounts/auth/set-password/verify-otp/`,
  verifyOtpServiceLogin: () => `${apiUrl}/api/accounts/login/verify-otp/`,
  userProfile: () => `${apiUrl}/api/accounts/profile/`,
  getPatientList: () => `${apiUrl}/api/accounts/get-patient-list/`,
  adminImpersonate: () => `${apiUrl}/api/accounts/admin/impersonate/`,
  changePasswordUser: () => `${apiUrl}/api/accounts/auth/change-password/`,
  getCountofOrder: () => `${apiUrl}/api/accounts/admin/system-stats/`,
  auditLogsList: (data) =>
    `${apiUrl}/api/accounts/patients/audit/logs/?page=${data?.page}&page_size=${data?.page_size}&patient_name=${data?.patient_name || ''}&patient_id=${data?.patient_id || ''}`,
  forgotPasswordService: () => `${apiUrl}/api/accounts/auth/forgot-password/`,
  resetPasswordService: () => `${apiUrl}/api/accounts/auth/reset-password/`,
  getOrderList: (id) => `${apiUrl}/api/accounts/patients/${id}/orders/?shopify=true`,
  resendOtpService: () => `${apiUrl}/api/accounts/auth/resend-otp/`,
  getProfileService: (user_id) => `${apiUrl}/api/setting/profile/${user_id}/`,
  updateProfileService: (user_id) => `${apiUrl}/api/setting/profile/${user_id}/update/`,
  getPlatformPreferencesService: (user_id) => `${apiUrl}/api/setting/platform-preferences/${user_id}/`,
  updatePlatformPreferencesService: (user_id) => `${apiUrl}/api/setting/platform-preferences-update/${user_id}/`,
  getGovernanceScoresService: (data) => `${apiUrl}/api/setting/governance-settings/${data}`,
  updateGovernanceScoresService: (user_id) => `${apiUrl}/api/setting/governance-settings/${user_id}/patch/`,
  getNotificationService: (user_id) => `${apiUrl}/api/setting/notification-settings/${user_id}/`,
  updateNotificationService: (user_id) => `${apiUrl}/api/setting/notification-settings/${user_id}/patch/`,
  supportService: (user_id) => `${apiUrl}/api/setting/support/submit/${user_id}/`,
  submitFeedbackService: (user_id) => `${apiUrl}/api/setting/feedback/submit/${user_id}/`,
  auditLogsService: (user_id) => `${apiUrl}/api/audit/audit-logs/${user_id}/`,
  downloadCSVService: (user_id) => `${apiUrl}/api/audit/logs/${user_id}/download-csv/`,
  getAuditLogCSVService: (user_id) => `${apiUrl}/api/audit/logs/${user_id}/download-csv/`,
  getRetentionPolicyService: (user_id) => `${apiUrl}/api/setting/retention-policies/${user_id}/`,
  updateRetentionPolicyService: (user_id, policy_id) => `${apiUrl}/api/setting/retention-policies/${user_id}/${policy_id}/update/`,
  getLegalPoliciesService: () => `${apiUrl}/api/setting/legal-policies/`,
  uploadLegalPolicyService: () => `${apiUrl}/api/setting/legal-policies/create/`,
  deleteLegalPolicyService: (policy_id) => `${apiUrl}/api/setting/legal-policies/${policy_id}/delete/`,
  downloadLegalPolicyService: (policy_id) => `${apiUrl}/api/setting/legal-policies/${policy_id}/download/`,
  getFeedbackService: () => `${apiUrl}/api/setting/feedback/`,
  getDateFormatService: () => `${apiUrl}/api/master/date-formats/`,
  getTimeZonesService: () => `${apiUrl}/api/master/timezones/`,
  getReviewerListService: () => `${apiUrl}/api/auth/users/reviewers-list/`,
  addReviewerService: () => `${apiUrl}/api/auth/users/reviewers/`,
  updateReviewerService: (reviewer_id) => `${apiUrl}/api/auth/reviewers/${reviewer_id}/`,
  deleteReviewerService: (reviewer_id) => `${apiUrl}/api/auth/reviewer/${reviewer_id}/delete/`,
  addApplicationService: () => `${apiUrl}/api/ai_portfolio/applications/`,
  updateApplicationService: (id) => `${apiUrl}/api/ai_portfolio/applications/${id}/`,
  getApplicationService: () => `${apiUrl}/api/ai_portfolio/applications/user/`,
  addModelService: () => `${apiUrl}/api/ai_portfolio/xtegrity-models/add/`,
  updateModelService: (id) => `${apiUrl}/api/ai_portfolio/xtegrity-models/${id}/update/`,
  getModelService: () => `${apiUrl}/api/ai_portfolio/xtegrity-models/list/`,
  getKnowledgeBaseService: () => `${apiUrl}/api/master/knowledge-hub/`,
  getCriticalLevelsService: () => `${apiUrl}/api/master/critical-levels/`,
  getUserIndustriesService: () => `${apiUrl}/api/ai_portfolio/user-industries/`,
  getSupportService: () => `${apiUrl}/api/setting/support/user/`,
  postSupportMessageService: (ticket_id) => `${apiUrl}/api/setting/support/${ticket_id}/message/`,
  getSupportChatByTicktService: (ticket_id) => `${apiUrl}/api/setting/support/${ticket_id}/chat/`,
  getGeographiesService: () => `${apiUrl}/api/master/geographies/`,
  getRegulationsByGeographyService: (application_id, geography_id) =>
    `${apiUrl}/api/ai_portfolio/regulations/?application_id=${application_id}&geography_id=${geography_id}`,
  getProtectedAttributesByUserService: () => `${apiUrl}/api/ai_portfolio/user-protected-attributes`,
  addUpdateProtectedAttributeService: () => `${apiUrl}/api/ai_portfolio/update-user-attributes/`,

  /** SuperAdmin */
  getAllReviewersService: () => `${apiUrl}/api/auth/users/all-reviewers/`,
  getAllApplicationsService: () => `${apiUrl}/api/ai_portfolio/applications/list/admin/`,
  addFAQService: () => `${apiUrl}/api/setting/faqs/create/`,
  updateFAQService: (fag_id) => `${apiUrl}/api/setting/faqs/${fag_id}/update/`,
  getFAQService: () => `${apiUrl}/api/setting/faqs/`,
  deleteFAQService: (fag_id) => `${apiUrl}/api/setting/faqs/${fag_id}/delete/`,
  getAllSupportService: () => `${apiUrl}/api/setting/support/all/`,
  getAllSupportChatList: () => `${apiUrl}/api/setting/support/all/`,
  updateSupportChatStatusService: (ticket_id) => `${apiUrl}/api/setting/support/${ticket_id}/status/`,
  startMedicationWithVoucher: () => `${apiUrl}/api/medication/start-medication/`,
  checkMedicationFormStatus: () => `${apiUrl}/api/medication/check-form-status/`,
  createPaymentIntent: () => `${apiUrl}/api/medication/create-payment-intent/`,
  getMedicationStatus: () => `${apiUrl}/api/medication/medication-status/`,
  getOfferings: () => `${apiUrl}/api/accounts/offerings/`,
  bulkUpdateOfferings: () => `${apiUrl}/api/accounts/offerings/bulk-update/`,
  suggestMedication: (patientId) => `${apiUrl}/api/accounts/patients/${patientId}/suggest-medication/`,
  getPatientOffering: () => `${apiUrl}/api/accounts/patient/offering/`,
  // OK Capsule supplements
  getSupplementProducts: () => `${apiUrl}/api/medication/supplements/products/`,
  syncSupplementProducts: () => `${apiUrl}/api/medication/supplements/products/sync/`,
  suggestSupplements: (patientId) => `${apiUrl}/api/medication/supplements/patients/${patientId}/suggest/`,
  getPatientSupplementSuggestions: (patientId) => `${apiUrl}/api/medication/supplements/patients/${patientId}/suggestions/`,
  getPatientSupplementOrders: (patientId) => `${apiUrl}/api/medication/supplements/patients/${patientId}/orders/`,
  orderReplacements: (orderId) => `${apiUrl}/api/accounts/orders/${orderId}/replacements/`,
  retryOrderReplacement: (replacementId) => `${apiUrl}/api/accounts/order-replacements/${replacementId}/retry/`,
  getNextStepCards: (patientId) => `${apiUrl}/api/accounts/patients/${patientId}/next-step-cards/`,
  setNextStepCards: (patientId) => `${apiUrl}/api/accounts/patients/${patientId}/next-step-cards/`,
  togglePortalLock: (patientId) => `${apiUrl}/api/accounts/patients/${patientId}/toggle-portal-lock/`,
  getRegistrationUrl: (patientId) => `${apiUrl}/api/accounts/registration-url/?patient_id=${patientId}`,
  getIntakeFormLink: (patientId) => `${apiUrl}/api/accounts/intake-form-link/?patient_id=${patientId}`,
  getPatientJotformSubmissions: (patientId) => `${apiUrl}/api/accounts/patients/${patientId}/jotform-submissions/`,
  getAdminReports: () => `${apiUrl}/api/reports/admin/patient-reports/`,
  updateAdminReport: (id) => `${apiUrl}/api/reports/admin/patient-reports/${id}/`,
  approveAdminReport: (id) => `${apiUrl}/api/reports/admin/patient-reports/${id}/approve/`,
  regenerateAdminReport: (id) => `${apiUrl}/api/reports/admin/patient-reports/${id}/regenerate/`,
  saveAdminReportPortalCopy: (id) => `${apiUrl}/api/reports/admin/patient-reports/${id}/portal-copy/`,
};

export default ApiUrlConstant;
